import { render, staticRenderFns } from "./UkrposhtaHead.vue?vue&type=template&id=c442807c&scoped=true"
import script from "./UkrposhtaHead.vue?vue&type=script&lang=js"
export * from "./UkrposhtaHead.vue?vue&type=script&lang=js"
import style0 from "./UkrposhtaHead.vue?vue&type=style&index=0&id=c442807c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c442807c",
  null
  
)

export default component.exports